var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('oie-my-pages-template',{attrs:{"title":_vm.t('informationTitle'),"text":_vm.t('informationSubTitle')}},[_c('oie-my-account'),_c('oie-base-divider'),_c('oie-my-notifications')],1)}
var staticRenderFns = []

export { render, staticRenderFns }